import { render } from "./editTenant.vue?vue&type=template&id=365f27f3&scoped=true"
import script from "./editTenant.vue?vue&type=script&lang=js"
export * from "./editTenant.vue?vue&type=script&lang=js"

import "./editTenant.vue?vue&type=style&index=0&id=365f27f3&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/rentalkenya_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-365f27f3"]])

export default __exports__